export default function pick<T, O extends keyof T>(obj: T, ...keys: O[]): Pick<T, O> {
  const ret = {} as Pick<T, O>;

  keys.forEach((key) => {
    ret[key] = obj[key];
  });

  return ret;
}
